__turbopack_context__.v({
  "blinker": "index-module-scss-module__LYtp7a__blinker",
  "button": "index-module-scss-module__LYtp7a__button",
  "hasSelected": "index-module-scss-module__LYtp7a__hasSelected",
  "methods": "index-module-scss-module__LYtp7a__methods",
  "selected": "index-module-scss-module__LYtp7a__selected",
  "switching": "index-module-scss-module__LYtp7a__switching",
});
